module.exports = __webpack_public_path__ + "static/img/海峽會.a4e1b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/海峽會.png?20181011
// module id = roVX
// module chunks = 1